<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p>This book is dedicated to all those people living in poor urban areas where opportunity is scarce. Those exposed to despair and negativity on a daily basis in this society may not realize the odds have been purposely stacked against some to prevent their success. Motivational speakers often talk a good talk, but if you lack resources, a motivational speaker isn’t speaking to those with absolutely no resources or hope. Sometimes we all need a helping hand—some more than others. I’ve often heard people assume and pass judgment on those struggling, branding them lazy and uninterested in bettering themselves, which is unfair. There are many good people in poor areas struggling to survive who just need that helping hand to improve their lives. Instead of sending billions to Ukraine and Israel, money could be used to offer resources to struggling citizens here. To those in this situation, I say keep your head up; when the person who can help, or the opportunity, comes around, I have confidence that you will seize it fully. And remember, what doesn’t kill you will make you stronger. Keep in mind that the ghetto/hood was created with a specific group in mind. Surviving the dangers that come from living in the hood will not only make you stronger but also more resilient. Hopefully, this story will be inspirational to those living in dire areas and situations.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?8445dfcc